import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import AccessGate from './components/AccessGate';
import './styles/global.css';

// Register the service worker generated by vite-plugin-pwa.
import { registerSW } from 'virtual:pwa-register';
registerSW({ immediate: true });

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AccessGate>
      <App />
    </AccessGate>
  </React.StrictMode>,
);
